import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import Icon from 'components/design-system/Icon'

/**
 * Empty State (Figma 113:18779): icon tile 48 + message Body/14 Regular — dùng cho grid / table / panel trống hoặc chưa chọn.
 * `icon` = tên icon registry (mặc định "info", màu icon/accent).
 */
const EmptyState = ({ icon = 'info', message, sx }) => (
  <Box
    sx={[
      { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'var(--space-12)', width: '100%', py: 'var(--space-24)' },
      ...(Array.isArray(sx) ? sx : [sx])
    ]}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 'var(--radius-md)', overflow: 'hidden' }}>
      <Icon name={icon} size={48} color="var(--color-icon-accent)" />
    </Box>
    <Box
      sx={{
        fontFamily: 'var(--font-family-primary)',
        fontWeight: 'var(--font-weight-regular)',
        fontSize: 'var(--font-size-14)', // Body/14 Regular
        lineHeight: 'normal',
        color: 'var(--color-text-primary)',
        textAlign: 'center'
      }}
    >
      {message}
    </Box>
  </Box>
)

EmptyState.propTypes = {
  icon: PropTypes.string,
  message: PropTypes.node,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

export default EmptyState
